import {
	Component,
	OnInit,
	ViewChild,
	TemplateRef,
	Input,
	Output,
	EventEmitter,
  } from '@angular/core';
  import { Router } from '@angular/router';
  import { NgxSpinnerService } from 'ngx-spinner';
  import { CommonService } from 'src/app/services/common/common.service';
  import { MatDialogRef, MatDialog } from '@angular/material/dialog';
  import { StorageService } from 'src/app/services/storage/storage.service';

  import * as ApexCharts from 'apexcharts';

  @Component({
	selector: 'app-agi-clients',
	templateUrl: './agi-clients.component.html',
	styleUrls: ['./agi-clients.component.scss']
})
export class AgiClientsComponent implements OnInit {
	graphSlideConfig = {
	  slidesToShow: 2,
	  slidesToScroll: 1,
	  infinite: false,
	  arrows: true,
	};

	user_details: any;

	@Input() selected_opportunity_period: any;
	@Output() stateChanged = new EventEmitter<any>();

	constructor(
	  private router: Router,
	  public commonService: CommonService,
	  private storageService: StorageService,
	  private spinner: NgxSpinnerService,
	  private dialog: MatDialog,
	) {}

	ngOnInit(): void {
	  this.spinner.show();
	  this.user_details = this.storageService.get('user_details');
	  this.getPageData();
	  // this.getadvisors();
	  this.getRegions();
	  // this.getAIAdvisorAssistants();
	}

	show_page_graphs: boolean = false;
	createGraphs() {
	  if (this.show_page_graphs == true) {
		// this.getPageData();
		setTimeout(() => {
		  this.createOppYearGraph();
		  this.createAIAssignedGraph();
		  this.createTypeGraph();
		  this.createAIAdvisorAssisgantActivitiesGraph();
		  this.createAIAdvisorAssistantTriggerGraph();
		  this.createProductsGraph();
		  this.createAgeGroupGraph();
		  this.createAUMGraph();

		  // this.getClientsData();
		}, 100);
	  }
	}

	selected_region = [];
	region_lists: any = [];
	getRegions() {
	  this.commonService.getData('/region?no_page=true/').subscribe(
		(res: any) => {
		  this.region_lists = res;
		  if (this.region_lists.length > 0) {
			for (let index = 0; index < this.region_lists.length; index++) {
			  this.selected_region.push(this.region_lists[index].id);
			}
		  }
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	page_loaded: boolean = false;
	page_data: any;
	getPageData() {
	  this.page_loaded = false;
	  this.commonService
		.getData(
		  '/advisoraiassistantassignedcharts/' + "?opp_year=" + this.selected_opportunity_period
		)
		.subscribe(
		  (res: any) => {
			this.page_data = res['data'];
			if (this.show_page_graphs == true) {
			  setTimeout(() => {
				this.createOppYearGraph();
				this.createAIAssignedGraph();
				this.createTypeGraph();
				this.createAIAdvisorAssisgantActivitiesGraph();
				this.createAIAdvisorAssistantTriggerGraph();
				this.createProductsGraph();
				this.createAgeGroupGraph();
				this.createAUMGraph();

			  }, 200);
			}
			// this.createGraphs();
			this.getClientsData();
			this.page_loaded = true;
		  },
		  (err) => {
			this.commonService.showToast('error', err.error);
			this.page_loaded = true;
		  },
		);
	}

	toggleGraphs() {
	  if (this.show_page_graphs == true) {
		this.getPageData();
	  }
	}

	opp_year_name: any = '';
	opp_year_id: any = '';
	createOppYearGraph() {
		let $this = this;
		var options = {
		// colors: ["#5EDEC7"],
		series: [
			{
				name: '',
				data: $this.page_data['yearly_opp']['y-axis'],
			},
		],
		chart: {
			type: 'bar',
			events: {
			dataPointSelection: function (event, chartContext, config) {
				const details = {
				id: $this.page_data['yearly_opp']['x-axis'][
					config.dataPointIndex
				],
				name: $this.page_data['yearly_opp']['x-axis'][
					config.dataPointIndex
				],
				};
				$this.opp_year_id =
				$this.opp_year_id == details.id ? '' : details.id;
				$this.opp_year_name =
				$this.opp_year_name == details.name ? '' : details.name;
				$this.current_pagination_page = 1;

				$this.getClientsData();
			},
			},
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			height: 286,
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById('opp-year-graph').clientWidth,
				$this.page_data['yearly_opp']['x-axis'].length,
				20,
			),
			endingShape: 'rounded',
			// dataLabels: {
			//   position: 'bottom'
			// },
			},
		},
		dataLabels: {
			enabled: false,
			textAnchor: 'start',
			style: {
			colors: ['#000000'],
			fontWeight: '200',
			},
			formatter: function (val, opt) {
			return opt.w.globals.labels[opt.dataPointIndex];
			},
			offsetX: 0,
			dropShadow: {
			enabled: false,
			},
		},
		stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		},
		xaxis: {
			categories: $this.page_data['yearly_opp']['x-axis'],
			title: {
			// text: 'Age Range'
			},
			crosshairs: {
				show: false,
			},
		},
		yaxis: {
			labels: {
				// show: false,
				show: true,
			},
		},
		fill: {
			opacity: 1,
		},
		};

		var chart = new ApexCharts(
		document.querySelector('#opp-year-graph'),
		options,
		);
		chart.render();
	}

	createAIAssignedGraph()  {
		  let $this = this;
	  var options = {
		series: $this.page_data['ai_assigned_graph']['data'],
		chart: {
		  height: 340,
		  type: 'radialBar',
		},
		plotOptions: {
		  radialBar: {
			dataLabels: {
			  hollow: {
				size: '80%',
			  },
			  name: {
				fontSize: '22px',
			  },
			  value: {
				fontSize: '16px',
			  },
			  total: {
				show: true,
				label: $this.page_data['ai_assigned_graph']['labels'][0],
				formatter: function (w) {
				  // By default this function returns the average of all series.
				  return $this.page_data['ai_assigned_graph']['data'][0] + "%";
				}
			  }
			}
		  }
		},
		labels: $this.page_data['ai_assigned_graph']['labels'],
	  };

	  var chart = new ApexCharts(document.querySelector("#ai-assigned-graph"), options);
	  chart.render();
	}

	type_name: any = '';
	  type_id: any = '';
	  createTypeGraph() {
		  let $this = this;

			  const options = {
				  colors: $this.page_data["type_graph"]['colors'],
				  series: $this.page_data["type_graph"]['data'],
				  chart: {
					  type: 'donut',
					  events: {
						  dataPointSelection: function (event, chartContext, config) {
							  const details = {
							  id: $this.page_data['type_graph']['labels'][config.dataPointIndex],
							  name: $this.page_data['type_graph']['labels'][config.dataPointIndex],
							  };
							  $this.type_id = $this.type_id == details.id ? '' : details.id;
							  $this.type_name = $this.type_name == details.name ? '' : details.name;
								$this.current_pagination_page = 1;
								$this.getClientsData();
						  },
					  },
					  toolbar: {
						  show: false,
					  },
					  zoom: {
						  enabled: false,
					  },
					  height: 330,
				  },
				  noData: {
					  text: 'No Data Available',
					  align: 'center',
					  verticalAlign: 'middle',
					  offsetX: 0,
					  offsetY: 0,
					  style: {
						  color: '#006AFF',
						  fontSize: '24px',
						  fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
					  },
				  },
				  plotOptions: {
					  pie: {
						  startAngle: 0
					  }
				  },
				  dataLabels: {
					  enabled: false,
				  },
				  labels: $this.page_data["type_graph"]['labels'],
				  legend: {
					  position: 'bottom',
					  enabled: false,
				  },
				  yaxis: {
					  title: {
						  text: '',
					  },
				  },
				  fill: {
					  opacity: 1,
				  },
			  };

		  var chart = new ApexCharts(
		  document.querySelector('#type-graph'),
		  options,
		  );
		  chart.render();

	  }

	createAIAdvisorAssisgantActivitiesGraph() {
	  let $this = this;
		  let label_colors: any = [];

		  for (let index = 0; index < $this.page_data['activity_radar']["x-axis"].length; index++) {
			  label_colors.push("#000000");
		  }

		  var options = {
			  colors: $this.page_data['activity_radar']['colors'],
			  series: [{
				  name: '',
				  data: $this.page_data['activity_radar']["y-axis"],
				  // data: [10, 20, 30, 10, 40, 66, 11, 33, 22, 77],
			  }],
			  chart: {
				  type: 'radar',
				  toolbar: {
					  show: false,
				  },
				  zoom: {
					  enabled: false,
				  },
				  height: 280,
			  },
			  plotOptions: {
				  radar: {
					size: 140,
					offsetX: 0,
					offsetY: 10,
					polygons: {
					  strokeColors: '#858a90',
					  strokeWidth: 1,
					  connectorColors: '#858a90',
					  // fill: {
					  // 	colors: ['#f8f8f8', '#fff']
					  // }
					}
				  }
				},
			  title: {
				  text: ''
			  },
			  yaxis: {
				  // stepSize: 20
			  },
			  xaxis: {
				  categories: $this.page_data['activity_radar']["x-axis"],
				  labels: {
					  style: {
					  //   colors: $this.page_data['activity_radar']['colors']
						colors: label_colors
					  },
				  },
			  },
		  };

		  var chart = new ApexCharts(document.querySelector("#ai-advisor-assistant-activities-graph"), options);
		  chart.render();
	}

	ai_advisor_assistant_trigger_name: any = '';
	ai_advisor_assistant_trigger_id: any = '';
	createAIAdvisorAssistantTriggerGraph() {
	  let $this = this;
	  var options = {
		// colors: "#D3D3D3",
		series: [
		  {
			name: '',
			data: $this.page_data['clients_by_ai_advisor_assistant_trigger']['y-axis'],
		  },
		],
		chart: {
		  type: 'bar',
		  events: {
			dataPointSelection: function (event, chartContext, config) {
			  const details = {
				id: $this.page_data['clients_by_ai_advisor_assistant_trigger'][
				  'labels'
				][config.dataPointIndex],
				name: $this.page_data['clients_by_ai_advisor_assistant_trigger'][
				  'x-axis'
				][config.dataPointIndex],
			  };
			  $this.ai_advisor_assistant_trigger_id =
				$this.ai_advisor_assistant_trigger_id == details.id ? '' : details.id;
			  $this.ai_advisor_assistant_trigger_name =
				$this.ai_advisor_assistant_trigger_name == details.name
				  ? ''
				  : details.name;
			  $this.current_pagination_page = 1;
			  $this.getClientsData();
			},
		  },
		  toolbar: {
			show: false,
		  },
		  zoom: {
			enabled: false,
		  },
		  height: 280,
		},
		noData: {
		  text: 'No Data Available',
		  align: 'center',
		  verticalAlign: 'middle',
		  offsetX: 0,
		  offsetY: 0,
		  style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
		  },
		},
		plotOptions: {
		  bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
			  document.getElementById('ai-advisor-assistant-trigger-graph')
				.clientWidth,
			  $this.page_data['clients_by_ai_advisor_assistant_trigger']['x-axis']
				.length,
			  20,
			),
			endingShape: 'rounded',
		  },
		},
		dataLabels: {
		  enabled: false,
		},
		// stroke: {
		//   show: true,
		//   width: 2,
		//   colors: ['transparent']
		// },
		xaxis: {
		  categories:
			$this.page_data['clients_by_ai_advisor_assistant_trigger']['x-axis'],
		  title: {
			// text: 'Value'
		  },
		  crosshairs: {
			show: false,
		  },
		},
		legend: {
		  position: 'bottom',
		},
		yaxis: {
		  title: {
			text: 'Count',
		  },
		},
		fill: {
		  opacity: 1,
		},
		tooltip: {
		  // y: {
		  //   formatter: function (val) {
		  //     return val
		  //   }
		  // }
		  custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			return (
			  '<div style="width:200px; padding:8px">' +
			  '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
			  $this.page_data['clients_by_ai_advisor_assistant_trigger']['legends'][
				dataPointIndex
			  ] +
			  '</p>' +
			  '<p><b>Value</b>: ' +
			  $this.page_data['clients_by_ai_advisor_assistant_trigger']['y-axis'][
				dataPointIndex
			  ] +
			  '</p>' +
			  '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
			  $this.page_data['clients_by_ai_advisor_assistant_trigger'][
				'description'
			  ][dataPointIndex] +
			  '</p>' +
			  '</div>'
			);
		  },
		  //  fixed: {
		  //   enabled: true,
		  //   position: "topRight"
		  // }
		},
	  };

	  var chart = new ApexCharts(
		document.querySelector('#ai-advisor-assistant-trigger-graph'),
		options,
	  );
	  chart.render();
	}

	product_name: any = '';
	product_id: any = '';
	createProductsGraph() {
	  let $this = this;
	  var options = {
		// colors: "#D3D3D3",
		series: [
		  {
			name: '',
			data: $this.page_data['clients_by_product']['y-axis'],
		  },
		],
		chart: {
		  type: 'bar',
		  events: {
			dataPointSelection: function (event, chartContext, config) {
			  const details = {
				id: $this.page_data['clients_by_product']['ids'][
				  config.dataPointIndex
				],
				name: $this.page_data['clients_by_product']['x-axis'][
				  config.dataPointIndex
				],
			  };
			  $this.product_id = $this.product_id == details.id ? '' : details.id;
			  $this.product_name =
				$this.product_name == details.name ? '' : details.name;
			  $this.current_pagination_page = 1;
			  $this.getClientsData();
			},
		  },
		  toolbar: {
			show: false,
		  },
		  zoom: {
			enabled: false,
		  },
		  height: 280,
		},
		noData: {
		  text: 'No Data Available',
		  align: 'center',
		  verticalAlign: 'middle',
		  offsetX: 0,
		  offsetY: 0,
		  style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
		  },
		},
		plotOptions: {
		  bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
			  document.getElementById('products-graph').clientWidth,
			  $this.page_data['clients_by_product']['x-axis'].length,
			  20,
			),
			endingShape: 'rounded',
		  },
		},
		dataLabels: {
		  enabled: false,
		},
		// stroke: {
		//   show: true,
		//   width: 2,
		//   colors: ['transparent']
		// },
		xaxis: {
		  categories: $this.page_data['clients_by_product']['x-axis'],
		  title: {
			// text: 'Value'
		  },
		  crosshairs: {
			show: false,
		  },
		},
		legend: {
		  position: 'bottom',
		},
		yaxis: {
		  title: {
			text: 'Count',
		  },
		},
		fill: {
		  opacity: 1,
		},
		// tooltip: {
		//   custom: function({series, seriesIndex, dataPointIndex, w}) {
		//     var data = $this.page_data["clients_by_product"]["tooltip"][dataPointIndex];
		//     data =  'Predicted AUM: $' + data.toLocaleString("en-US") + "<br>";

		//     var count = $this.page_data["clients_by_product"]["y-axis"][dataPointIndex]
		//     count = 'count : ' + count;

		//     return data + count;
		//   },
		//   fixed: {
		//     enabled: true,
		//     position: "topRight"
		//   }
		// }
		// tooltip: {
		//   y: {
		//     formatter: function (val) {
		//       return val
		//     }
		//   }
		// }
	  };

	  var chart = new ApexCharts(
		document.querySelector('#products-graph'),
		options,
	  );
	  chart.render();
	}

	age_group_name: any = '';
	age_group_id: any = '';
	createAgeGroupGraph() {
	  let $this = this;
	  var options = {
		// colors: "#D3D3D3",
		series: [
		  {
			name: '',
			data: $this.page_data['clients_by_ages']['y-axis'],
		  },
		],
		chart: {
		  type: 'bar',
		  events: {
			dataPointSelection: function (event, chartContext, config) {
			  const details = {
				id: $this.page_data['clients_by_ages']['x-axis'][
				  config.dataPointIndex
				],
				name: $this.page_data['clients_by_ages']['x-axis'][
				  config.dataPointIndex
				],
			  };
			  $this.age_group_id =
				$this.age_group_id == details.id ? '' : details.id;
			  $this.age_group_name =
				$this.age_group_name == details.name ? '' : details.name;
			  $this.current_pagination_page = 1;
			  $this.getClientsData();
			},
		  },
		  toolbar: {
			show: false,
		  },
		  zoom: {
			enabled: false,
		  },
		  height: 280,
		},
		noData: {
		  text: 'No Data Available',
		  align: 'center',
		  verticalAlign: 'middle',
		  offsetX: 0,
		  offsetY: 0,
		  style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
		  },
		},
		plotOptions: {
		  bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
			  document.getElementById('age-group-graph').clientWidth,
			  $this.page_data['clients_by_ages']['x-axis'].length,
			  20,
			),
			endingShape: 'rounded',
		  },
		},
		dataLabels: {
		  enabled: false,
		},
		stroke: {
		  show: true,
		  width: 0,
		  colors: ['transparent'],
		},
		xaxis: {
		  categories: $this.page_data['clients_by_ages']['x-axis'],
		  title: {
			// text: 'Value'
		  },
		  crosshairs: {
			show: false,
		  },
		},
		yaxis: {
		  title: {
			text: 'Count',
		  },
		},
		fill: {
		  opacity: 1,
		},
		// tooltip: {
		//   custom: function({series, seriesIndex, dataPointIndex, w}) {
		//     var data = $this.page_data["clients_by_time"]["tooltip"][dataPointIndex];
		//     var count = $this.page_data["clients_by_time"]["y-axis"][dataPointIndex];
		//     data = 'Predicted AUM: $' + data.toLocaleString("en-US") + "<br>";
		//     count = 'Count :' + count;

		//     return  data + count;
		//   },
		//   fixed: {
		//     enabled: true,
		//     position: "topRight"
		//   }
		// }
	  };

	  var chart = new ApexCharts(
		document.querySelector('#age-group-graph'),
		options,
	  );
	  chart.render();
	}

	aum_name: any = '';
	aum_min_id: any = '';
	aum_max_id: any = '';
	createAUMGraph() {
	  let $this = this;
	  var options = {
		// colors: "#D3D3D3",
		series: [
		  {
			name: '',
			data: $this.page_data['clients_by_aum']['y-axis'],
		  },
		],
		chart: {
		  type: 'bar',
		  events: {
			dataPointSelection: function (event, chartContext, config) {
			  const details = {
				id: $this.page_data['clients_by_aum']['ids'][
				  config.dataPointIndex
				],
				name: $this.page_data['clients_by_aum']['x-axis'][
				  config.dataPointIndex
				],
			  };
			  const value = details.id.split('-');
			  $this.aum_min_id = $this.aum_min_id == value[0] ? '' : value[0];
			  $this.aum_max_id = $this.aum_max_id == value[1] ? '' : value[1];
			  $this.aum_name = $this.aum_name == details.name ? '' : details.name;
			  $this.current_pagination_page = 1;
			  $this.getClientsData();
			},
		  },
		  toolbar: {
			show: false,
		  },
		  zoom: {
			enabled: false,
		  },
		  height: 280,
		},
		noData: {
		  text: 'No Data Available',
		  align: 'center',
		  verticalAlign: 'middle',
		  offsetX: 0,
		  offsetY: 0,
		  style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
		  },
		},
		plotOptions: {
		  bar: {
			horizontal: false,
			columnWidth: $this.commonService.getBarGraphPercentWidth(
			  document.getElementById('aum-graph').clientWidth,
			  $this.page_data['clients_by_aum']['x-axis'].length,
			  20,
			),
			endingShape: 'rounded',
		  },
		},
		dataLabels: {
		  enabled: false,
		},
		stroke: {
		  show: true,
		  width: 0,
		  colors: ['transparent'],
		},
		xaxis: {
		  categories: $this.page_data['clients_by_aum']['x-axis'],
		  title: {
			// text: 'Value'
		  },
		  crosshairs: {
			show: false,
		  },
		},
		yaxis: {
		  title: {
			text: 'Count',
		  },
		},
		fill: {
		  opacity: 1,
		},
		// tooltip: {
		//   custom: function({series, seriesIndex, dataPointIndex, w}) {
		//     var data = $this.page_data["clients_by_time"]["tooltip"][dataPointIndex];
		//     var count = $this.page_data["clients_by_time"]["y-axis"][dataPointIndex];
		//     data = 'Predicted AUM: $' + data.toLocaleString("en-US") + "<br>";
		//     count = 'Count :' + count;

		//     return  data + count;
		//   },
		//   fixed: {
		//     enabled: true,
		//     position: "topRight"
		//   }
		// }
	  };

	  var chart = new ApexCharts(document.querySelector('#aum-graph'), options);
	  chart.render();
	}

	navigateToPage(url) {
	  this.router.navigate([url]);
	}

	abbreviateNumber(value) {
	  let fixed = 1;
	  let num = value;
	  if (num === null) {
		return null;
	  }
	  if (num === 0) {
		return '0';
	  }
	  fixed = !fixed || fixed < 0 ? 0 : fixed;
	  var b = num.toPrecision(2).split('e'),
		k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		c =
		  k < 1
			? num.toFixed(0 + fixed)
			: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		d = c < 0 ? c : Math.abs(c),
		e = d + ['', 'K', 'M', 'B', 'T'][k];
	  return e;

	  // value = Math.round(value);
	  // let new_value = value;
	  // if (value >= 1000) {
	  //     const suffixes = ["", "K", "M", "B","T"];
	  //     const suffixNum = Math.floor( (""+value).length/3 );
	  //     let shortValue: any = '';
	  //     for (var precision = 2; precision >= 1; precision--) {
	  //         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
	  //         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
	  //         if (dotLessShortValue.length <= 2) { break; }
	  //     }
	  //     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
	  //     new_value = shortValue+suffixes[suffixNum];
	  // }
	  // return new_value;
	}

	calculateWidth(data, value) {
	  let total = 0;
	  for (let index = 0; index < data.length; index++) {
		const count = parseInt(data[index]['count']);
		total = total + count;
	  }
	  const width = (value / total) * 100 + '%';
	  return width;
	}

	search_key: any = '';

	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;

	selected_alphabet = '';
	alphabets_array = [
	  'A',
	  'B',
	  'C',
	  'D',
	  'E',
	  'F',
	  'G',
	  'H',
	  'I',
	  'J',
	  'K',
	  'L',
	  'M',
	  'N',
	  'O',
	  'P',
	  'Q',
	  'R',
	  'S',
	  'T',
	  'U',
	  'V',
	  'W',
	  'X',
	  'Y',
	  'Z',
	];
	show_search: boolean = false;
	table_columns: any = [
	  {
		name: 'Client ID',
		key: 'client_id',
		checked: true,
	  },
	  {
		name: 'Type',
		key: 'type',
		checked: true,
	  },
	  {
		name: 'AUM',
		key: 'total_aum',
		checked: true,
	  },
	  {
		name: 'First Name',
		key: 'first_name',
		checked: true,
	  },
	  {
		name: 'Last Name',
		key: 'last_name',
		checked: true,
	  },
	  {
		name: 'No.of Products',
		key: 'no_of_products',
		checked: true,
	  },
	  {
		name: 'Email',
		key: 'email',
		checked: true,
	  },
	  {
		name: 'Phone Number',
		key: 'telephone_number',
		checked: true,
	  },
	  {
		name: 'Client Status',
		key: 'status',
		checked: true,
	  },
	  {
		name: 'Actions',
		key: 'actions',
		checked: true,
	  },
	];
	table_data: any = [];
	selected_table_data: any = [];
	table_data_loaded: boolean = false;
	show_toggle_columns: boolean = false;
	getClientsData() {

	  this.show_activity_view = null;

	  this.table_data_loaded = false;
	  const search_key = this.search_key;

	  const user_details = this.storageService.get('user_details');

	  let route: any =
		'/client?records_per_page=' +
		this.pagination_records_limit +
		'&search=' +
		this.search_key +
		'&alphabet=' +
		this.selected_alphabet +
		'&page=' +
		this.current_pagination_page +
		'&advisor=' +
		this.user_details.id +
		'&ai_advisor_assistant=true';

		if (this.type_id != '') {
		  route =
			route +
			'&ai_opp_type=' +
			this.type_id;
		}

	  if (this.ai_advisor_assistant_trigger_id != '') {
		route =
		  route +
		  '&clients_by_ai_advisor_assistant_trigger=' +
		  this.ai_advisor_assistant_trigger_id;
	  }

	  if (this.product_id != '') {
		route = route + '&clients_by_product=' + this.product_id;
	  }

	  if (this.age_group_id != '') {
		route = route + '&clients_by_agegroup=' + this.age_group_id;
	  }

	  if (this.aum_min_id != '') {
		route = route + '&aum_min=' + this.aum_min_id;
	  }

	  if (this.aum_max_id != '') {
		route = route + '&aum_max=' + this.aum_max_id;
	  }

	  if (this.opp_year_id != '') {
		route = route + "&yearly_filter=" + this.opp_year_id;
	  } else {
			  route = route + "&opp_year=" + this.selected_opportunity_period;
		  }



	  this.commonService.getData(route).subscribe(
		(res: any) => {
		  this.table_columns = res['results']['columns'];
		  if (this.table_columns.length > 0) {
			for (let index = 0; index < 9; index++) {
			  this.table_columns[index].checked = true;
			}
		  }
		  this.table_data = res['results']['data'];
		  this.current_pagination_page = res.page_number;
		  this.total_pagination_records = res.total_no_of_records;
		  this.table_data_loaded = true;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	pageChanged(event) {

	  this.show_activity_view = null;

	  this.current_pagination_page = event;
	  this.pagination_records_limit = this.pagination_records_limit;
	  this.getClientsData();
	}

	getKey(data, column) {
	  const key = column['key'];
	  return data[key];
	}

	is_selected: boolean = false;
	selectAll(event) {
	  if (event.checked == true) {
		this.selected_table_data = JSON.parse(JSON.stringify(this.table_data));
		this.is_selected = true;
	  } else {
		this.selected_table_data = [];
		this.is_selected = false;
	  }
	}

	checkIndividualSelection(data) {
	  const index = this.selected_table_data.findIndex(
		(obj) => obj.id == data.id,
	  );
	  if (index != -1) {
		return true;
	  } else {
		return false;
	  }
	}

	selectIndividual(event, data) {
	  const index = this.selected_table_data.findIndex(
		(obj) => obj.id == data.id,
	  );
	  if (index != -1) {
		if (event.checked == true) {
		  this.selected_table_data.splice(index, 0, data);
		} else {
		  this.selected_table_data.splice(index, 1);
		}
	  } else {
		this.selected_table_data.splice(index, 0, data);
	  }
	  if (this.table_data.length == this.selected_table_data.length) {
		this.is_selected = true;
	  } else {
		this.is_selected = false;
	  }
	}

	@ViewChild('clientDataModal') clientDataModal: TemplateRef<any>;
	private clientDataModalRef: MatDialogRef<TemplateRef<any>>;

	selected_client: any;
	selected_modal_client_loader: boolean = false;;
	openClientDataModal(data) {
	  this.selected_client = JSON.parse(JSON.stringify(data));
	  this.selected_modal_client_loader = true;
	  this.clientDataModalRef = this.dialog.open(this.clientDataModal, { disableClose: true });
	  this.clientDataModalRef.afterClosed().subscribe((result) => {
		this.closeClientDataModal();
	  });

	  this.commonService.getData('/customerdetails/?id=' + this.selected_client.id).subscribe(
		(res: any) => {
		  this.selected_client = res["data"];
		  this.selected_modal_client_loader = false;
		},
		(err) => {
		  this.commonService.showToast('error', err.error);
		},
	  );
	}

	closeClientDataModal() {
	  this.selected_client = {};
	  this.clientDataModalRef.close();
	}

	@ViewChild('assignAIAdvisorAssistantModal')
	assignAIAdvisorAssistantModal: TemplateRef<any>;
	private assignAIAdvisorAssistantModalRef: MatDialogRef<TemplateRef<any>>;

	openAssignAIAdvisorAssistantModal() {
	  this.assignAIAdvisorAssistantModalRef = this.dialog.open(
		this.assignAIAdvisorAssistantModal, { disableClose: true }
	  );
	  this.assignAIAdvisorAssistantModalRef.afterClosed().subscribe((result) => {
		this.closeAssignAIAdvisorAssistantModal();
	  });
	}

	tooltipText: any =  "<p>Once the response is captured, client will be moved to selected sales process</p>"

	closeAssignAIAdvisorAssistantModal() {
	  this.ai_advisor_assistant = '';
	  this.ai_advisor_assistant_error = false;
	  this.ai_advisor_assistant_activity_status = '';
	  this.ai_advisor_assistant_activity_status_error = false;
	  this.ai_advisor_assistant_comments = '';
	  this.ai_advisor_assistant_comments_error = false;
	  this.ai_advisor_assistant_sales_process = '';
	  this.ai_advisor_assistant_sales_process_error = false;

	  this.assigning_ai_advisor_assistant_loader = false;

	  this.assignAIAdvisorAssistantModalRef.close();
	}

	captureResponse() {
	  if (this.selected_table_data.length > 0) {
		this.openAssignAIAdvisorAssistantModal();
	  } else {
		this.commonService.showToast(
		  'error',
		  'Please Select minimum one Client to capture response',
		);
	  }
	}

	ai_advisor_assistant: any = '';
	ai_advisor_assistant_error: any = false;
	ai_advisor_assistant_activity_status: any = '';
	ai_advisor_assistant_activity_status_error: any = false;
	ai_advisor_assistant_comments: any = '';
	ai_advisor_assistant_comments_error: any = false;
	ai_advisor_assistant_sales_process: any = '';
	ai_advisor_assistant_sales_process_error: any = false;

	assigning_ai_advisor_assistant_loader: boolean = false;

	moveToSalesProcess() {
	  if (this.ai_advisor_assistant_sales_process != '' && this.ai_advisor_assistant_sales_process != null) {
		this.ai_advisor_assistant_sales_process_error = false;
	  } else {
		this.ai_advisor_assistant_sales_process_error = true;
	  }

	  if (this.ai_advisor_assistant != '' && this.ai_advisor_assistant != null) {
		this.ai_advisor_assistant_error = false;
	  } else {
		this.ai_advisor_assistant_error = true;
	  }

	  if (this.ai_advisor_assistant == "Interested") {
		if (
		  this.ai_advisor_assistant_activity_status != "" && this.ai_advisor_assistant_activity_status != null
		) {
		  this.ai_advisor_assistant_activity_status_error = false;
		} else {
		  this.ai_advisor_assistant_activity_status_error = true;
		}
	  } else if (this.ai_advisor_assistant == "Not Interested") {
		if (this.ai_advisor_assistant_comments != "" && this.ai_advisor_assistant_comments != null) {
		  this.ai_advisor_assistant_comments_error = false;
		} else {
		  this.ai_advisor_assistant_comments_error = true;
		}
	  } else {
		this.ai_advisor_assistant_activity_status_error = false;
		this.ai_advisor_assistant_comments_error = false;
	  }

	  if (
		this.ai_advisor_assistant_error == false &&
		this.ai_advisor_assistant_activity_status_error == false &&
		this.ai_advisor_assistant_comments_error == false &&
		this.ai_advisor_assistant_sales_process_error == false
	  ) {
		this.assigning_ai_advisor_assistant_loader = true;
		let payload: any = {
		  ai_advisor_assistant_client_response: this.ai_advisor_assistant,
		  ai_advisor_assistant_client_activities: this.ai_advisor_assistant_activity_status,
		  ai_advisor_assistant_client_comments: this.ai_advisor_assistant_comments,
		  ai_advisor_assistant_sales_process: this.ai_advisor_assistant_sales_process,
		  ai_advisor_assistant_client_list: [],
		};

		for (let index = 0; index < this.selected_table_data.length; index++) {
		  payload.ai_advisor_assistant_client_list.push(this.selected_table_data[index].id);
		}

		this.commonService.postData('/captureaiadvisorassistantclientresponse/', payload).subscribe(
		  (res: any) => {
			this.selected_table_data = [];
			this.getClientsData();
			this.commonService.showToast(
			  'success',
			  'Client Conversion Status changed Successfully.',
			);

			this.countChanged.emit("Changed");

			this.closeAssignAIAdvisorAssistantModal();
			this.assigning_ai_advisor_assistant_loader = false;
		  },
		  (err) => {
			this.assigning_ai_advisor_assistant_loader = false;
			this.commonService.showToast('error', err.error);
		  },
		);
	  }
	}

	@Output() countChanged = new EventEmitter<any>();

	back() {
	  this.stateChanged.emit('Summary');
	}

	show_activity_view: number = null;
	toggleActivityView(value) {
	  if (this.show_activity_view == value) {
		this.show_activity_view = null;
	  } else {
		// this.getTasks(value);
		this.show_activity_view = value;
	  }
	}

	tasks_data: any = [];
	getTasks(index) {
	  this.tasks_data = [];
	  this.commonService
		.getData(
		  '/clientsalesactivity/?client=' +
			this.table_data[index].id +
			'&ai_assistant=true&no_page=true',
		)
		.subscribe(
		  (res: any) => {
			this.tasks_data = res;
			for (let index = 0; index < this.tasks_data.length; index++) {
			  this.commonService
				.getData(
				  '/clientsalesactivitycomments?clientsales_activity=' +
					this.tasks_data[index].id +
					'&ordering=id&no_page=true',
				)
				.subscribe(
				  (comments: any) => {
					this.tasks_data[index].comments = [];
					for (let cIndex = 0; cIndex < comments.length; cIndex++) {
					  this.tasks_data[index].comments.push(comments[cIndex]);
					}
				  },
				  (err) => {
					this.commonService.showToast('error', err.error);
				  },
				);
			}
		  },
		  (err) => {
			this.commonService.showToast('error', err.error);
		  },
		);
	}

	dataChanged(event) {
	  this.show_activity_view = null;
	  this.getClientsData();
	  // this.changeStepper();
	}

	show_user_profile: boolean = false;
	  user_profile_data: any;
	  showUserProfile(data) {
		this.user_profile_data = JSON.parse(JSON.stringify(data));
		this.show_user_profile = true;
	  }

	  profileClosed(event) {
		this.user_profile_data = {};
		this.show_user_profile = false;
	  }

  }
